module.exports = __webpack_public_path__ + "img/desktop.e3ce1235.png";